import { render, staticRenderFns } from "./admin-add-games.vue?vue&type=template&id=3073c042&"
import script from "./admin-add-games.vue?vue&type=script&lang=js&"
export * from "./admin-add-games.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports